import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import { Title } from '../../style';
import SentToMeDrawer from './drawer/SentToMeDrawer';
import MergeCommandsDrawer from '../../mergeCommands/drawer/MergeCommandsDrawer';
import EnhancedTable from './table/EnhancedTable';

/**
 * Composant principale englobant toute la section réception
 */
const SentToMe = () => (
  <div>
    <Grid container spacing={10}>
      <Grid item md={3}>
        <Title>Réception</Title>
      </Grid>
    </Grid>
    <SentToMeDrawer />
    <MergeCommandsDrawer />
    <EnhancedTable />
  </div>
);

export default withRouter(SentToMe);
